import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable()
export class XRequestedByInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const augmentedReq = req.clone({
      headers: req.headers.set("X-Requested-With", "XMLHttpRequest"),
    });

    return next.handle(augmentedReq);
  }
}
